import React from 'react';
import Layout from '../layout';
import HardwareHero from '../assets/v2/png/HardwareHero.png';
import DigitalSectionOne from '../components/Esper/DigitalSignage/DigitalSectionOne';
import DigitalSectionTwo from '../components/Esper/DigitalSignage/DigitalSectionTwo';
import DigitalSectionThree from '../components/Esper/DigitalSignage/DigitalSectionThree';
import DigitalSectionFour from '../components/Esper/DigitalSignage/DigitalSectionFour';
import DigitalSectionFive from '../components/Esper/DigitalSignage/DigitalSectionFive';
// import DigitalSectionSix from '../components/Esper/DigitalSignage/DigitalSectionSix';
import DigitalSectionSeven from '../components/Esper/DigitalSignage/DigitalSectionSeven';
import messages from '../i18n/en';

import DigitalSectionSix from '../components/Esper/DigitalSignage/DigitalSixTemp';
import BlogPosts from './../components/Esper/HomePage/BlogPosts';
export default (props: any) => (
  <Layout
    messages={messages}
    ogImage={HardwareHero}
    title={
      'Leading Platform for Digital Signage Solution Builders | Gain control of your Digital Signages across the country '
    }
    description={`Esper is the first-ever suite of solutions designed to simplify the creation, configuration and deployment of digital signage solutions.`}
    keywords={`Android Digital Signage,Digital Signage softwares,Digital Signage solution`}
    className="first-page"
    location={props.location}
  >
    <DigitalSectionOne />
    <DigitalSectionTwo />
    <DigitalSectionThree />
    <DigitalSectionFour />
    <DigitalSectionFive />
    <DigitalSectionSix />
    <DigitalSectionSeven messages={messages} />
    <BlogPosts />
  </Layout>
);
